<template>
  <div class="pa-40">
    <h1 class="has-text-weight-bold is-size-4 has-text-primary mb-20">
      {{title}}
    </h1>
    <div class="columns">
      <div class="column is-5">
        <figure class="image">
          <img :src="func.getImg(panneau.srcImg)">
        </figure>
      </div>
      <div class="column">
        <gmap-map
          :center="panneau.adresse.coordonnees"
          :zoom="18"
          :options="{
            mapTypeControlOptions: mapType,
          }"
          @tilesloaded="actionMapIsLoaded"
          ref="mapPanneau"
          class="googleMap">

          <gmap-marker
            v-if="isMapLoaded && panneau"
            :position="panneau.adresse.coordonnees"
            :icon="getIconPanneau()">
          </gmap-marker>

        </gmap-map>
      </div>
    </div>
    <div class="columns">
      <div class="column is-5">
        <div class="columns is-multiline">
          <div class="column is-12" v-if="adresse">
            <h3 class="has-text-weight-bold is-size-18px has-text-primary">
              {{$t('recapRecom.recapPanneau.titreAdresse')}}
            </h3>
            <p class="is-size-14px has-text-grid-1">
              {{adresse}}
            </p>
          </div>
          <div class="column is-12" v-if="panneau.commentaire">
            <h3 class="has-text-weight-bold is-size-18px has-text-primary">
              {{$t('recapRecom.recapPanneau.titreCommentaire')}}
            </h3>
            <p class="is-size-14px has-text-grid-1">
              {{panneau.commentaire}}
            </p>
          </div>
        </div>
      </div>
      <div class="column">
        <h3 class="has-text-weight-bold is-size-18px has-text-primary">
          {{$t('recapRecom.recapPanneau.carcteristique.titre')}}
        </h3>
        <p
          class="is-size-14px has-text-grid-1"
          v-if="panneau.referencePanneau">
          {{$t('recapRecom.recapPanneau.carcteristique.reference')}} {{panneau.referencePanneau}}
        </p>
        <p
          class="is-size-14px has-text-grid-1"
          v-if="panneau.regie">
          {{$t('recapRecom.recapPanneau.carcteristique.regie')}} {{panneau.regie}}
        </p>
        <p
          class="is-size-14px has-text-grid-1"
          v-if="panneau.categorie.libelle">
          {{$t('recapRecom.recapPanneau.carcteristique.categorie')}} {{panneau.categorie.libelle}}
        </p>
        <p
          class="is-size-14px has-text-grid-1"
          v-if="panneau.format">
          {{$t('recapRecom.recapPanneau.carcteristique.format')}} {{panneau.format}}
        </p>
        <p
          class="is-size-14px has-text-grid-1"
          v-if="panneau.materiel">
          {{$t('recapRecom.recapPanneau.carcteristique.materiel')}} {{panneau.materiel}}
        </p>
        <p
          class="is-size-14px has-text-grid-1"
          v-if="panneau.support">
          {{$t('recapRecom.recapPanneau.carcteristique.support')}} {{panneau.support}}
        </p>
        <p
          class="is-size-14px has-text-grid-1"
          v-if="panneau.azimut">
          {{$t('recapRecom.recapPanneau.carcteristique.azimut')}} {{panneau.azimut}}°
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { MAP_TYPE_CONTROL_OPTIONS, STYLE_MAPS_POI_HIDDEN, MAP_TYPE_NAME } from '@/configuration/configurationCarte';
import { COULEUR_PANNEAU_SOUS_CONTRAT } from '@/configuration/configPanneau';
import { iconColorGetter, TAILLE_ICON_PLUS_GRAND } from '@/services/gestionIcon/iconColorGetter';
import { getImg, adressFullStringGetter } from '@/services/general/general';

export default {
  props: {
    panneau: Object,
    index: Number,
  },
  data () {
    return {
      mapType: MAP_TYPE_CONTROL_OPTIONS,
      isMapLoaded: false,
      func: { getImg }
    };
  },
  computed: {
    adresse() {
      return this.panneau.adresseCommerciale || adressFullStringGetter(this.panneau.adresse);
    },
    title() {
      return this.$t('recapRecom.recapPanneau.titreRecomAffichage', {
        type: this.panneau.categorie.libelle,
        numero: this.index + 1,
      });
    },
  },
  methods: {
    getIconPanneau() {
      const { estPanneauSousContrat, estRenouvellement, categorie, azimut } = this.panneau;
      const couleur = (estPanneauSousContrat || estRenouvellement) ? COULEUR_PANNEAU_SOUS_CONTRAT : categorie.couleur;
      return iconColorGetter(couleur, TAILLE_ICON_PLUS_GRAND, azimut, true);
    },
    async actionMapIsLoaded() {
      if (!this.isMapLoaded) {
        const styleMap = new google.maps.StyledMapType(
          STYLE_MAPS_POI_HIDDEN,
          { name: MAP_TYPE_NAME },
        );
        this.$refs.mapPanneau.$mapPromise.then((map) => {
          map.mapTypes.set("styled_map", styleMap);
        });
        this.isMapLoaded = true;
      }
    }
  },
};
</script>
